import { render, staticRenderFns } from "./ThemeIcon.vue?vue&type=template&id=5767eaa6&"
import script from "./ThemeIcon.vue?vue&type=script&lang=js&"
export * from "./ThemeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports